function countRemainingCharacters(elementId, maxLength) {
    const selector  = document.getElementById(elementId);
    const formGroup = selector.closest('.form-group');

    formGroup.querySelector('.text-count').innerHTML = maxLength - selector.value.length;
}
